import React, { useEffect, useState } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import partnership from "../../../assets/images/intern_banner.png";
import partnershipMobile from "../../../assets/images/intern_banner.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  addPartnership,
  getAllAreas,
  getAllTypes,
  getEntitiesClassification,
} from "../../../apis/actions/partnership.actions";
import { Col, Divider, Row, Form, Checkbox } from "antd";
import AddPartnershipButton from "../../../biblio/Buttons/AddPartnershipButton";
import Inputs from "../../../biblio/Inputs/Inputs";
import Selects from "../../../biblio/Selects/Selects";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import Loader from "../../../biblio/Loader/Loader";
import { UploadOutlined } from "@ant-design/icons";
import UploadInput from "../../../biblio/Inputs/UploadInput";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../components/utils/utils";
import { useNavigate } from "react-router-dom";
import { setResIds ,setResModel } from "../../../apis/slices/ratingSlice";
const AddPartnership = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [selectedTypes, setSelectedTypes] = useState<any[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<any[]>([]);
  useState<any>(false);
  const [activeEntity, setActiveEntity] = useState<any>(null);
  const navigate = useNavigate();
  const { entities, partnershipTypes, areas, loading } = useSelector(
    (state: RootState) => state?.partnership
  );
  useEffect(() => {
    if (entities && entities.length > 0 && activeEntity === null) {
      setActiveEntity(entities[0]?.id);
    }
  }, [entities, activeEntity]);
  useEffect(() => {
    dispatch(getEntitiesClassification());
    dispatch(getAllTypes());
    dispatch(getAllAreas());
  }, [dispatch]);

  const options = [
    { id: "day", name: "يوم" },
    { id: "week", name: "أسبوع" },
    { id: "month", name: "شهر" },
    { id: "year", name: "سنة" },
  ];

  const handleEntitySelection = (id: string) => {
    setActiveEntity(id);
  };
  const handleFileChange = async (fileList: any[]) => {
    const attachments = [];
    for (const fileItem of fileList) {
      const file = fileItem?.originFileObj;
      if (file) {
        try {
          const base64 = await convertFileToBase64(file);
          const imageData = {
            filename: file.name,
            data: base64,
          };
          attachments.push(imageData);
          form.setFieldsValue({
            attachment_ids: attachments,
          });
        } catch (error) {
          console.error("Error converting file to Base64:", error);
        }
      }
    }
  };

  const onFinish = async () => {
    try {
      await form.validateFields();

      const FormValues = form.getFieldsValue();

      const partnershipDurationUnit = form.getFieldValue(
        "partnership_duration_unit"
      );

      let partnershipFormData = {
        ...FormValues,
        entity_classification_id: activeEntity,
        partnership_type_id: selectedTypes,
        partnership_duration_unit: partnershipDurationUnit?.value || "year",
        partnership_areas_ids: selectedAreas,
      };
      dispatch(addPartnership(partnershipFormData)).then((result: any) => {
        const partnership = result?.payload?.data?.result;
        if (partnership?.code === 200) {
          dispatch(setResModel(partnership?.res_model));
          dispatch(setResIds([partnership?.partnership_request_id]))
          showNotitfication(partnership?.message, "success");
          setTimeout(() => {
            navigate("/");
            window.scrollTo(0, 0);
          }, 3000);
        } else {
          showNotitfication(partnership?.message, "error");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const isOtherSelected = areas?.some(
    (area: any) => area?.is_other && selectedAreas.includes(area?.id)
  );

  const handleCheckboxAreaChange = (areaId: any) => {
    if (selectedAreas.includes(areaId)) {
      setSelectedAreas(selectedAreas.filter((id) => id !== areaId));
      form.setFieldsValue({ other: "" });
    } else {
      setSelectedAreas([...selectedAreas, areaId]);
    }
  };

  const handleCheckboxTypeChange = (typeId: any) => {
    if (selectedTypes.includes(typeId)) {
      setSelectedTypes(selectedTypes.filter((id) => id !== typeId));
    } else {
      setSelectedTypes([...selectedTypes, typeId]);
    }
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <MenuItemLayout
          mobileImage={partnershipMobile}
          title="الشراكات"
          subTitle="طلب شراكة"
          urlImage={partnership}
          className="takaful--add-partnership"
        >
          <Form form={form} layout="vertical">
            <div className="takaful--add-partnership-container">
              <Row gutter={[16, 16]} justify={"start"}>
                <Col
                  style={{ display: "flex" }}
                  xxl={14}
                  xl={14}
                  lg={16}
                  md={16}
                  sm={24}
                  xs={24}
                >
                  {entities?.map((entity: any) => (
                    <Col
                      xxl={6}
                      xl={6}
                      lg={8}
                      md={8}
                      sm={8}
                      xs={8}
                      className="takaful--add-partnership-col"
                    >
                      <Form.Item name="entity_classification_id">
                        <AddPartnershipButton
                          className={
                            activeEntity === entity?.id
                              ? "takaful--add-partnership-active-button"
                              : ""
                          }
                          onClick={() => handleEntitySelection(entity?.id)}
                          title={entity?.name}
                        />
                      </Form.Item>
                    </Col>
                  ))}
                </Col>
              </Row>
              <Divider className="takaful--add-partnership-divider" />
              <Form.Item
                name="name"
                label="موضوع الشراكة"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                className="takaful--label-inputs"
                labelCol={{ className: "takaful--label-style" }}
                style={{ marginTop: "1rem" }}
              >
                <Inputs type="text" />
              </Form.Item>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="partner_name"
                    label="اسم الجهة"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="city"
                    label="المدينة"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="entity_email"
                    label="البريد الإلكتروني"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                      {
                        type: "email",
                        message:
                          "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs placeholder="email@example.com" type="email" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="entity_mobile"
                    label="رقم الهاتف/الجوال"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                      {
                        len: 10,
                        message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs
                      placeholder="05XXXXXXXX"
                      type="tel"
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="street"
                    label="العنوان"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
              </Row>

              <h1 className="takaful--add-partnership-title">
                معلومات الشراكة
              </h1>
              <Row gutter={16} dir="rtl" style={{ marginTop: "1rem" }}>
                <Col xxl={6} xl={6} lg={6} md={6} sm={10} xs={10}>
                  <p className="takaful--add-partnership-subtitle">
                    نوع الشراكة المطلوبة
                  </p>
                </Col>

                <Col xxl={18} xl={18} lg={18} md={18} sm={14} xs={14}>
                  <Form.Item
                    name="partnership_type_id"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء إدخال اختيار واحد على الأقل",
                      },
                    ]}
                  >
                    <Row gutter={16}>
                      {partnershipTypes?.map((type: any) => (
                        <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                          <Form.Item
                            name="partnership_type_id"
                            valuePropName="partnership_type_id"
                          >
                            <Checkbox
                              onChange={() =>
                                handleCheckboxTypeChange(type?.id)
                              }
                            >
                              <span className="takaful--check-partnershipstyle">
                                {type?.name}
                              </span>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl" style={{ marginTop: "1rem" }}>
                <Col xxl={6} xl={6} lg={6} md={6} sm={10} xs={10}>
                  <p className="takaful--add-partnership-subtitle">
                    مجالات الشراكة
                  </p>
                </Col>

                <Col xxl={18} xl={18} lg={18} md={18} sm={14} xs={14}>
                  <Form.Item
                    name="partnership_areas_ids"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء إدخال اختيار واحد على الأقل",
                      },
                    ]}
                  >
                    <Row gutter={16}>
                      {areas?.map((area: any) => (
                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                          <Form.Item
                            name="partnership_areas_ids"
                            valuePropName="partnership_areas_ids"
                          >
                            <Checkbox
                              onChange={() =>
                                handleCheckboxAreaChange(area?.id)
                              }
                            >
                              <span className="takaful--check-partnershipstyle">
                                {area?.name}
                              </span>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>
                  </Form.Item>
                  {isOtherSelected && (
                    <Col
                      style={{ marginRight: "1rem", marginTop: "-2.5rem" }}
                      xxl={8}
                      xl={8}
                      lg={8}
                      md={8}
                      sm={24}
                      xs={24}
                    >
                      <Form.Item
                        name="other"
                        rules={[
                          {
                            required: true,
                            message: "الرجاء تعبئة الحقل",
                          },
                        ]}
                        className="takaful--label-inputs"
                        labelCol={{ className: "takaful--label-style" }}
                      >
                        <Inputs
                          value={form.getFieldValue("other")}
                          placeholder="أخرى (تذكر)"
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item
                    name="execution_location"
                    label="مكان التنفيذ"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={14} sm={14} xs={14}>
                  <Form.Item
                    name="partnership_duration"
                    label="مدة الشراكة"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="tel" />
                  </Form.Item>
                </Col>
                <Col xxl={4} xl={4} lg={4} md={10} sm={10} xs={10}>
                  <Form.Item
                    name="partnership_duration_unit"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs takaful--select-partnership-unit"
                    labelCol={{ className: "takaful--label-style" }}
                    initialValue={"year"}
                  >
                    <Selects options={options} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="comment"
                    label="تفاصيل مجالات التعاون"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
              </Row>
              <h1 className="takaful--add-partnership-title">بيانات التواصل</h1>
              <Row gutter={16} dir="rtl" style={{ marginTop: "1rem" }}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="contact_name"
                    label="اسم ممثل الجهة"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="phone"
                    label="رقم الهاتف/الجوال"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                      {
                        len: 10,
                        message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs
                      placeholder="05XXXXXXXX"
                      type="tel"
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="function"
                    label="المنصب"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs type="text" />
                  </Form.Item>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="email_from"
                    label="البريد الالكتروني"
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                      {
                        type: "email",
                        message:
                          "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
                      },
                    ]}
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <Inputs placeholder="email@example.com" type="email" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} dir="rtl">
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="attachment_ids"
                    label="إرفاق أي مستندات تدعم الطلب"
                    className="takaful--label-inputs"
                    labelCol={{ className: "takaful--label-style" }}
                  >
                    <UploadInput
                      text="إرفاق أي مستندات تدعم الطلب"
                      icon={<UploadOutlined />}
                      multiple={true}
                      onChange={handleFileChange}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row dir="rtl" justify={"end"} style={{ marginTop: "3rem" }}>
                <Col
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  xxl={12}
                  xl={12}
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <PrimaryButton
                    className="takaful--add-partnership-button"
                    title="إرسال الطلب"
                    onClick={() => {
                      onFinish();
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Form>
        </MenuItemLayout>
      )}
    </>
  );
};

export default AddPartnership;
